import {SectionsContainer} from '../../core/definitions/sections-container';

/**
 * Tracks the last edited section so it can be brought back into view after "Lagre".
 * Saving without closing reloads the edit form, which collapses open inline items
 * and can leave the section above the visible area.
 */
export class SaveScrollRestorer {
  private lastSectionId: string | undefined;
  private lastContainer: SectionsContainer | undefined;

  rememberFocus(target: EventTarget | null) {
    const section = target instanceof Element ? target.closest('[id^="section-"]') : null;
    if (section) {
      this.lastSectionId = section.id;
    }
  }

  /**
   * Returns the section to scroll back to when the sections container has been replaced
   * by a reload of the same object while still editing.
   */
  checkReload(container: SectionsContainer | undefined, isEditing: boolean): string | undefined {
    const previous = this.lastContainer;
    this.lastContainer = container;
    if (!previous || !container || previous === container) {
      return undefined;
    }
    if (!isEditing || previous.rootObject.artifact_id !== container.rootObject.artifact_id) {
      this.lastSectionId = undefined;
      return undefined;
    }
    return this.lastSectionId;
  }
}

export function isOutsideView(element: Element, viewport: Element): boolean {
  const rect = element.getBoundingClientRect();
  const view = viewport.getBoundingClientRect();
  return rect.bottom <= view.top || rect.top >= view.bottom;
}
